import CircularProgress from '@mui/material/CircularProgress';
import { Route, Switch } from 'react-router-dom';

import AddTeam from './AddTeam';
import InviteTeamMember from './InviteTeamMember';
import InviteTeamMemberV2 from './InviteTeamMemberV2';
import TeamSettings from './Settings';
import TeamMembersView from './TeamMembers';
import TeamMembersV2 from './TeamMembersV2';
import { Backdrop } from '../../components/Backdrop';
import NoResourcePage from '../../components/NoResourcePage';
import RequestProductionAccessMessage from '../../components/RequestProductionAccessMsg';
import useApp from '../../hooks/useApp';
import useTeam from '../../hooks/useTeam';
import { isValidJwt } from '../../lib/jwt';
import Routes from '../../lib/routes';

export default function TeamRouter(): JSX.Element {
  const { app } = useApp();
  const { allTeams } = useTeam();
  const token = app.tokens.get(app.env);

  if (allTeams === undefined) {
    return (
      <Backdrop open={true}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  if (allTeams === null && isValidJwt(token)) {
    return <RequestProductionAccessMessage />;
  }

  if (allTeams?.length === 0) {
    return (
      <Switch>
        {/* user should still be able to add team */}
        <Route path={Routes.Teams.AddTeam}>
          <AddTeam />
        </Route>
        {/* for any other routes, we will show no teams */}
        <Route>
          <NoResourcePage
            title="Team Settings"
            subtitle="You do not belong to any teams. Please create a team to get started"
            buttonText="Create Team"
            buttonHref={Routes.Teams.AddTeam}
          />
        </Route>
      </Switch>
    );
  }

  return (
    <Switch>
      <Route path={Routes.Teams.InviteMember}>
        <InviteTeamMember />
      </Route>
      <Route path={Routes.Teams.InviteMemberV2}>
        <InviteTeamMemberV2 />
      </Route>
      <Route path={Routes.Teams.AddTeam}>
        <AddTeam />
      </Route>
      <Route path={Routes.Teams.Settings}>
        <TeamSettings />
      </Route>
      <Route path={Routes.Teams.MembersV2}>
        <TeamMembersV2 />
      </Route>
      <Route path={Routes.Teams.Base}>
        <TeamMembersView />
      </Route>
    </Switch>
  );
}
